import axios from 'axios'
import { UrlBase } from './configConversations'
import { UrlBase as UrlBaseAdmin, OAuthUrlBase } from './config'

const conversations = {}

conversations.connectionWithGmail = async (companyUUID, appUUID, gmailIsConnected) => {
  try {
    let url = `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/gmail/`

    if (gmailIsConnected) {
      url += 'unauthorize'
    } else {
      url += 'authorize'
    }

    const request = {
      method: 'POST',
      url
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getAdvisers = async (token, companyUUID, appUUID, status) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'GET',
      params: {
        status
      },
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/adviser/status`
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getAppInfo = async (token, companyId, appId, data) => {
  const { getStatistics } = data

  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: { getStatistics },
      url: `${UrlBaseAdmin}companies/${companyId}/apps/${appId}`
    }

    const response = await axios(request)
    return response.data.app
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getFunnelData = async (token, companyUUID, appUUID, data) => {
  const { endReason, fromDate, toDate } = data

  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        endReason,
        fromDate: fromDate + 'T00:00-05:00',
        toDate: toDate + 'T23:59-05:00'
      },
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/funnel`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getRooms = async (token, companyUUID, appUUID, data) => {
  const { pagination, search, advancedSearch } = data

  try {
    const params = {
      params: {
        filter: advancedSearch.displayMethod,
        idCard: advancedSearch.idCard,
        code: advancedSearch.code,
        phone: advancedSearch.phone,
        page: pagination.page,
        search: search,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage
      }
    }

    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/rooms`,
      ...params
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getUserByPhoneRoom = async (token, companyUUID, appUUID, phone) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBaseAdmin}companies/${companyUUID}/apps/${appUUID}/users/from/phone?phone=${phone}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getStatistics = async (token, companyUUID, appUUID, data) => {
  const { advisorId, endReason, fromDate, toDate } = data

  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        advisorId,
        endReason,
        fromDate: fromDate + 'T00:00-05:00',
        toDate: toDate + 'T23:59-05:00'
      },
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/statistics`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getWatchingEmail = async (companyUUID, appUUID) => {
  try {
    const request = {
      method: 'GET',
      url: `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/gmail/watching`
    }

    const response = await axios(request)

    return response.data.enabled
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.transferAdviser = async (token, companyUUID, appUUID, data) => {
  try {
    const { adviserId, roomId, selectedOption } = data
    const request = {
      data: {
        advisorId: adviserId,
        selectedOption: selectedOption
      },
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'PUT',
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/room/${roomId}/transfer`
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.updateCache = async (token, companyUUID, appUUID, data) => {
  try {
    const request = {
      data: {
        deleteWaitingAdvisor: data
      },
      method: 'POST',
      url: `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/general/refresh`
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getUrlAuthorization = async (companyUUID, appUUID) => {
  try {
    const request = {
      method: 'GET',
      url: OAuthUrlBase + 'google/auth',
      headers: {
        Authorization: 'Bearer 01A6F40C29F0A98B37D1287A80B165AFE665B78D6524F79CB297626370FAF040'
      },
      params: {
        companyUUID: companyUUID,
        appUUID: appUUID
      }
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.revokeCredentials = async (companyUUID, appUUID) => {
  try {
    const request = {
      method: 'GET',
      url: OAuthUrlBase + 'google/revoke',
      headers: {
        Authorization: 'Bearer 01A6F40C29F0A98B37D1287A80B165AFE665B78D6524F79CB297626370FAF040'
      },
      params: {
        companyUUID: companyUUID,
        appUUID: appUUID
      }
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getConnectedEmails = async (companyUUID, appUUID) => {
  try {
    const request = {
      method: 'GET',
      url: OAuthUrlBase + 'google/email',
      headers: {
        Authorization: 'Bearer 01A6F40C29F0A98B37D1287A80B165AFE665B78D6524F79CB297626370FAF040'
      },
      params: {
        companyUUID: companyUUID,
        appUUID: appUUID
      }
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.error('Error al traer todos los emails de la appUUID ', e)
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.uploadImage = async (token, companyUUID, appUUID, roomID, totalFiles, onUploadProgress) => {
  try {
    const formData = new FormData()
    for (const file of totalFiles) {
      formData.append('img', file)
    }
    const request = {
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      onUploadProgress,
      url: `${UrlBase}uploads/images/company/${companyUUID}/app/${appUUID}/room/${roomID}`
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getChannelsInfo = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyId}/app/${appId}/Channels`
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getChannelsWithWhatsApp = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyId}/app/${appId}/autostarts`
    }

    const response = await axios(request)
    return response.data.channels
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.updateSmoochInfo = async (token, companyId, appId, data) => {
  const { phone, smoochAppId, smoochKeyId, smoochKeySecret, smoochIntegrationId, enable, country, number, namespace } = data
  try {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyId}/app/${appId}/Smooch`,
      data: {
        phone,
        smoochAppId,
        smoochKeyId,
        smoochKeySecret,
        smoochIntegrationId,
        enable,
        country,
        number,
        namespace
      }
    }

    const response = await axios(request)
    return response
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.updateFbInfo = async (token, companyId, appId, data) => {
  const { pageId, verificationToken } = data
  try {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyId}/app/${appId}/FBmessenger`,
      data: {
        page_id: pageId,
        verification_token: verificationToken
      }
    }

    const response = await axios(request)
    return response
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.createSmoochInfo = async (token, companyId, appId, data) => {
  const { phone, smoochAppId, smoochKeyId, smoochKeySecret, smoochIntegrationId, enable, country, number, namespace } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyId}/app/${appId}/Smooch`,
      data: {
        phone,
        smoochAppId,
        smoochKeyId,
        smoochKeySecret,
        smoochIntegrationId,
        enable,
        country,
        number,
        namespace
      }
    }

    const response = await axios(request)
    return response
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.createFbInfo = async (token, companyId, appId, data) => {
  const { pageId, verificationToken } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyId}/app/${appId}/FBmessenger`,
      data: {
        page_id: pageId,
        verification_token: verificationToken
      }
    }

    const response = await axios(request)
    return response
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.deleteFacebookInfo = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyId}/app/${appId}/FBMessenger`
    }

    const response = await axios(request)
    return response
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.uploadPdf = async (token, companyUUID, appUUID, roomID, file, onUploadProgress) => {
  try {
    const formData = new FormData()

    formData.append('pdf', file)

    const request = {
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      onUploadProgress,
      url: `${UrlBase}uploads/pdf/company/${companyUUID}/app/${appUUID}/room/${roomID}`
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.uploadAudio = async (token, companyUUID, appUUID, roomID, audio, onUploadProgress) => {
  try {
    const formData = new FormData()

    formData.append('audio', audio)

    const request = {
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      onUploadProgress,
      url: `${UrlBase}uploads/audio/company/${companyUUID}/app/${appUUID}/room/${roomID}`
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.uploadVideo = async (token, companyUUID, appUUID, roomID, video, onUploadProgress) => {
  try {
    const formData = new FormData()

    formData.append('video', video)

    const request = {
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      onUploadProgress,
      url: `${UrlBase}/uploads/video/company/${companyUUID}/app/${appUUID}/room/${roomID}`
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getRatings = async (token, companyUUID, appUUID, data) => {
  const { fromDate, toDate } = data

  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        fromDate: fromDate + 'T00:00-05:00',
        toDate: toDate + 'T23:59-05:00'
      },
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/ratings`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getBotConfusions = async (token, companyUUID, appUUID, data) => {
  const { fromDate, toDate } = data

  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        fromDate: fromDate + 'T00:00-05:00',
        toDate: toDate + 'T23:59-05:00'
      },
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/botconfusions`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.getProactivity = async (token, companyUUID, appUUID, data) => {
  const { fromDate, toDate } = data

  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        fromDate: fromDate + 'T00:00-05:00',
        toDate: toDate + 'T23:59-05:00'
      },
      url: `${UrlBase}chat/company/${companyUUID}/app/${appUUID}/proactivity`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.createEndConversationAgent = async (token, companyUUID, appUUID) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/endConversation`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.deleteEndConversationAgent = async (token, companyUUID, appUUID) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/endConversation`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}
conversations.createInactivityMessageAgent = async (token, companyUUID, appUUID) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/inactivityMessage`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.deleteInactivityMessageAgent = async (token, companyUUID, appUUID) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/inactivityMessage`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

conversations.updateTemplates = async (token, companyUUID, appUUID) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}configurations/company/${companyUUID}/app/${appUUID}/updateTemplates`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.success)
  }
}

export default conversations
